import { useSiteImages } from '../../hooks/useSiteImages';
import { useInstagramMedia } from '../../hooks/useInstagramMedia';
import { ImageWithFallback } from '../ui/ImageWithFallback';
import { SectionHeading } from './SectionHeading';

const INSTAGRAM_SLOTS = ['instagram-1', 'instagram-2', 'instagram-3', 'instagram-4', 'instagram-5', 'instagram-6'];
const INSTAGRAM_URL = 'https://www.instagram.com/babychic.sm';

function InstagramIcon() {
  return (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <rect x="3" y="3" width="18" height="18" rx="5" strokeWidth={1.5} />
      <circle cx="12" cy="12" r="4" strokeWidth={1.5} />
      <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
    </svg>
  );
}

function PlayIcon() {
  return (
    <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="white" viewBox="0 0 24 24">
      <path d="M8 5v14l11-7z" />
    </svg>
  );
}

const VIDEO_MEDIA_TYPES = new Set(['VIDEO', 'REELS']);

export function InstagramShowcase() {
  const { media, isLoading: isLoadingMedia } = useInstagramMedia();
  const { siteImages, isLoading: isLoadingImages, error } = useSiteImages();

  if (isLoadingMedia || isLoadingImages || error) return null;

  const hasRealMedia = media.length > 0;
  const hasFallbackPhoto = INSTAGRAM_SLOTS.some((slot) => Boolean(siteImages[slot]));
  if (!hasRealMedia && !hasFallbackPhoto) return null;

  return (
    <div className="max-w-6xl mx-auto px-4 pt-12 pb-4">
      <div className="flex items-center justify-between gap-4 mb-4">
        <SectionHeading title="Siga a Baby Chic" className="" />
        <a
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-sm font-semibold text-chocolate-dark hover:text-chocolate transition-colors whitespace-nowrap"
        >
          <InstagramIcon />
          @babychic.sm
        </a>
      </div>

      <div className="grid grid-cols-3 lg:grid-cols-6 gap-1.5 sm:gap-2">
        {hasRealMedia
          ? media.slice(0, 6).map((item) => {
              const isVideo = VIDEO_MEDIA_TYPES.has(item.mediaType ?? '');
              const imageSrc = isVideo ? item.thumbnailUrl : item.mediaUrl;
              return (
                <a
                  key={item.id}
                  href={item.permalink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="relative block group"
                >
                  <ImageWithFallback
                    src={imageSrc}
                    alt={item.caption || 'Foto da Baby Chic no Instagram'}
                    className="aspect-square rounded-md group-hover:opacity-90 transition-opacity"
                  />
                  {isVideo && (
                    <span className="absolute inset-0 flex items-center justify-center pointer-events-none">
                      <span className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-black/40 flex items-center justify-center">
                        <PlayIcon />
                      </span>
                    </span>
                  )}
                </a>
              );
            })
          : INSTAGRAM_SLOTS.map((slot) => (
              <ImageWithFallback
                key={slot}
                src={siteImages[slot]}
                alt="Foto da Baby Chic no Instagram"
                className="aspect-square rounded-md"
              />
            ))}
      </div>
    </div>
  );
}
